import { Component, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { GlobalComponent } from 'src/app/global/global.component';
import { HttpClient } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { EnvironmentService } from './environment.service';
import { onboardingservice } from './pages/onboarding/onboarding.service';
import { JwtHelper } from 'angular2-jwt';
import { PWAService } from './progressivewebservice';
import { HostListener } from '@angular/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  private onDestroy$: Subject<void> = new Subject<void>();
  public settings: Settings;
  menu: any;
  loginData: any = {};
  agencyData: any = {};
  locationData: any = 0;
  menusitems: any = {};
  agencyList: any = {};
  agencydropdown: any = {};
  EnvironmentConfig: any;
  JwtHelper: JwtHelper = new JwtHelper();
  decodedToken: any;
  refreshData: any = {};
  appUserData: any = {}
  constructor(public appSettings: AppSettings, public OnboardService: onboardingservice, public EnvironmentService: EnvironmentService, public toasterService: ToastrService, private router: Router, public global: GlobalComponent, private http: HttpClient,
    private ref: ChangeDetectorRef, public serviceWorkers: PWAService) {
    this.settings = this.appSettings.settings;
    this.appUserData = JSON.parse(localStorage.getItem("CFSS_login"));
    this.EnvironmentConfig = this.EnvironmentService.getEnvironmentsConfiguration();

    if (
      this.appUserData != null &&
      this.appUserData != undefined &&
      this.appUserData != ""
    ) {
      this.serviceWorkers.checkForUpdates();
      const Params = new URLSearchParams(window.location.search)
      const CustomerName: any = Params.get("CustomerName");
      const CustomerId: any = Params.get("CustomerId");
      this.global.CxCustomerId = CustomerId;
      this.global.CxCustomerName = CustomerName;


      let clientNewTab = JSON.parse(localStorage.getItem("cfss_ClientNewTabFunctionality"));
      console.log(clientNewTab,"cfss_ClientNewTabFunctionality");
      
      if (clientNewTab != null) {
        this.global.isClientNewTab = clientNewTab.isClientNewTab;
        this.global.searchClientStatus = "Active";
        this.global.EventClientid = clientNewTab.ClientId;

      }

    }
  }
   @HostListener("window:message", ["$event"])
      onMessage(event: MessageEvent) {
        // Always validate the message origin
        // const trustedOrigin = 'https://your-iframe-origin.com';
        if (event.origin !== this.EnvironmentConfig?.receiveAgentWidgetMessage) return;
    
        if (event.data?.type === "OPEN_PAGES") {
          let clientData = event.data?.filters;
          console.log(clientData);
          this.newtab(clientData?.clientId)
          
        }
      }
  ngOnInit() {
    this.global.isassignboolean=false;
    let onboardrole = localStorage.getItem("CFSS_OnboardLoginType");
    this.global.deviceWidth = window.innerWidth;
    this.global.OnboardType = onboardrole;
    let appUserData = JSON.parse(localStorage.getItem("CFSS_login"));
    this.global.cfssLoginEntityId = localStorage.getItem("CFSS_loginId")
    let CFSS_checkType = localStorage.getItem("CFSS_checkType")

    let agencyCode = localStorage.getItem("CFSS_agencyCode")
    if (agencyCode != null && agencyCode != undefined && agencyCode != '') {
      this.global.agencyCode = agencyCode;
    }
    if (CFSS_checkType != null) {
      this.global.OnboardingLoginType = CFSS_checkType;
    }
    if (this.global.OnboardingLoginType == "agencyLogin") {
      this.global.LoginUserType = 'Admin';
      if (appUserData != null) {
        this.global.authtoken = appUserData.accessToken;
        this.global.refreshTokenString = this.refreshData;

        this.decodedToken = this.JwtHelper.decodeToken(this.global.authtoken);

        this.global.globalAgencyId = this.decodedToken.AGENCYID
        this.global.refreshToken()
          .then(data => {
            this.global.scheduleRefresh();
            appUserData = JSON.parse(localStorage.getItem("CFSS_login"));
            this.refreshData = JSON.parse(localStorage.getItem("CFSS_refreshtoken "));
            this.global.assignToken(appUserData);
            this.global.getOverallAgencyDropDown();
            this.getSideMenus();
            if ((this.global.selectedAgencyDropdown == null || this.global.selectedAgencyDropdown == undefined || this.global.selectedAgencyDropdown == '') && (this.decodedToken.AGENCYID == null || this.decodedToken.AGENCYID == undefined || this.decodedToken.AGENCYID == '')) {
              this.global.globalAgencyId = "00000000-0000-0000-0000-000000000000";
              this.global.globalLocationList = [];
            }
            else if (this.global.loginusername != "SUPERADMIN") {
              this.global.getLocationforagencyuser();
            }
            else {
              this.global.GetLocationDropDown();
            }
            this.global.getOverallAgencyDropDown();
            this.global.getAgencySetting();
          })
          .catch(err => {
            this.global.agencyLogo = null;
            this.global.agencyName = null;
            this.global.agencyPhone = null;
            this.global.globalAgencyId = '';
            this.global.globalLocationId = '';
            this.global.selectedLocationDropdown = '';
            this.global.ngLocationDropDown = [];
            this.global.userRoleDropDown = []
            this.global.userSelectedRole = ""
            this.global.globalAgencyDropdown = "";
            console.log("logout from cfss")
            window.postMessage("stop", "*");
             Object.keys(localStorage).forEach(key => {
              if (!key.toLowerCase().includes('grid')) {  // 🔒 keep grid state
                localStorage.removeItem(key);
              }
            });
            this.global.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
            this.router.navigateByUrl("/login");
          })
      }
    }
    else if (this.global.OnboardingLoginType == "onboardLogin") {
      this.global.LoginUserType = 'Onboard'

      this.global.authtoken = appUserData.accessToken;
      this.global.refreshTokenString = appUserData.refreshToken;
      this.global.OnboardingrefreshToken()
        .then(data => {
          this.global.OnboardingscheduleRefresh();
          this.global.OnboardType =localStorage.getItem("CFSS_OnboardLoginType");
          appUserData = JSON.parse(localStorage.getItem("CFSS_login"));
          this.global.assignOnboardingToken(appUserData);
        
        })
        .catch(err => {

          this.global.agencyLogo = null;
          this.global.agencyName = null;
          this.global.agencyPhone = null;
          this.global.globalAgencyId = '';
          this.global.globalLocationId = '';
          this.global.selectedLocationDropdown = '';
          this.global.ngLocationDropDown = [];
          this.global.userRoleDropDown = []
          this.global.userSelectedRole = ""
          this.global.globalAgencyDropdown = "";
          this.global.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
          console.log("logout from cfss")
          window.postMessage("stop", "*");
          this.global.LogoutFunction();
           Object.keys(localStorage).forEach(key => {
          if (!key.toLowerCase().includes('grid')) {  // 🔒 keep grid state
            localStorage.removeItem(key);
          }
        });
        })
    }

    //..............................CFSS_sidebars///////////////////////////////////
    this.menusitems = localStorage.getItem("CFSS_sidebars");
    this.menusitems = JSON.parse(this.menusitems);
    let roles = localStorage.getItem("CFSS_roles");
    ///..................................CFSS_agencydetails........................................
    this.agencyList = JSON.parse(localStorage.getItem("CFSS_agencydetails"));
    this.global.globalHeadAgencyId =this.agencyList?.agencyId;
    this.global.employeeId=this.agencyList?.employeeId;
    //......................................CFSS_agencyNames........................................
    this.agencydropdown = JSON.parse(localStorage.getItem("CFSS_agencyNames"));
    //...................................CFSS_login.................................................
    let onboardagencycode = localStorage.getItem("CFSS_onboardagencycode")
    this.loginData = localStorage.getItem("CFSS_login");
    this.loginData = JSON.parse(this.loginData);
    this.agencyData = JSON.parse(localStorage.getItem("CFSS_globalagencydetails"));



    this.global.agencyId = this.agencyData?.id;

    if (this.global.OnboardingLoginType == "agencyLogin") {
      if (this.loginData != null) {
        this.global.assignToken(this.loginData);
        //CFSS_agencydetails
        if (this.agencyList != null) {
          this.global.getAgencyDetails(this.agencyList)
        }
        //Menu_items//
        if (this.menusitems != null) {
          this.global.AddMenuItems(this.menusitems)
        }
        //agencyData//
        if (this.agencyData != null) {
          this.global.Addagencydata(this.agencyData);


          this.global.globalAgencyDropdown = this.agencyData.agencyId;
          this.global.selectedAgencyDropdown = this.agencyData.agencyId;
          this.global.selectAgencyCode = this.agencyData.agencyCode
        }
        //agencydropdown
        if (this.agencydropdown != null) {
          this.global.AddAgencyDropdown(this.agencydropdown);
        }
        //locationId
        this.locationData = JSON.parse(localStorage.getItem("CFSS_location"));
        if (this.global.selectedLocationDropdown != null) {
          this.global.selectedLocationDropdown = this.locationData;

        }
        else {
          this.global.selectedLocationDropdown = null;
        }
       if (this.global.agencyCode?.toLocaleUpperCase() !== "SUPERADMIN") {
          if (
            this.global.CxCustomerName != null &&
            this.global.CxCustomerName != undefined &&
            this.global.CxCustomerName != "" &&
            this.global.CxCustomerId != null &&
            this.global.CxCustomerId != undefined &&
            this.global.CxCustomerId != ""
          ) {
            this.router.navigateByUrl("/Client");
          } else {                        
            if (this.global?.isClientNewTab) {             
              this.router.navigateByUrl("/Client");
            } 

            else {
              this.router.navigateByUrl("/splash");
            }
          }
         
        } else {
          if (this.global?.isClientNewTab) {             
              this.router.navigateByUrl("/Client");
            } 
            else
          this.router.navigateByUrl("/splash");
        }
      }
    }
    else if (this.global.OnboardingLoginType == "onboardLogin") {
      let tenantDetails = JSON.parse(localStorage.getItem("CFSS_CXTenantDetails"));


      this.global.cxTenantDetails = tenantDetails
 
  

      this.global.onboardingdetails(this.loginData);
      if (this.menusitems != null) {
        this.global.onboardsideMenus(this.menusitems)
      }
      this.global.CFSS_onboardagencycode = onboardagencycode;
    }
    else {
      let url = window.location.href;

      if (!(url.includes("onboarding/client") || url.includes("onboarding/employee"))) {

        this.router.navigateByUrl("/login");
      }
      else {

        let urlpath = url.split('#')
        this.router.navigateByUrl(urlpath[1]);

      }
    }
    if (this.global.OnboardingLoginType == "onboardLogin") {

      if (onboardrole == "EMPLOYEE") {
        this.getEmployeeSideMenus();
        this.global.isClientOnboard == false
      }
      else {

        this.getClientSideMenus();
        this.global.isClientOnboard == true
        this.router.navigateByUrl("/splash");
      }


    }
    // if (this.global.OnboardingLoginType == "onboardLogin") {

    //   if (onboardrole == "EMPLOYEE") {
    //     this.getEmployeeSideMenus();
    //     this.global.isClientOnboard == false
    //   }
    //   else {

    //     this.getClientSideMenus();
    //     this.global.isClientOnboard == true
    //     this.router.navigateByUrl("/importpayment");
    //   }


    // }
  }
  scroll = (event: any): void => {

    this.ref.detach();
    setInterval(() => {
      this.ref.detectChanges();
    }, 10);

  };
  //........................................getSideMenus........................................................................
  getSideMenus() {
    var url = "api/Auth/GetSideMenus";
    this.http.get(url).subscribe((data: any) => {

      this.global.AddMenuItems(data);
      localStorage.setItem("CFSS_sidebars", JSON.stringify(data));
    },
      (err: any) => {
        if (err) {
          this.toasterService.error(err, 'Error'), 8000;
        }
      })
  }
  ngAfterViewInit() {
    document.getElementById('preloader').classList.add('hide');
  }
  //............................... getuserDropDown...................................................
  getuserDropDown(id: string) {
    var url = "api/User/Getuserroledropdown?";
    let myParams = new URLSearchParams();
    myParams.append("userid", id);
    this.http.get(url + myParams).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.global.userRoleDropDown = data;
    });
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  getClientSideMenus() {
    this.OnboardService.getsideMenuforClientOnboarding().subscribe((data: any) => {
      this.setMenudata(data);
      localStorage.setItem("CFSS_sidebars", JSON.stringify(data));
    },
      (err: any) => {
        if (err) {
          this.toasterService.error(err, 'Error'), 8000;
        }
      })
  }
  // .................................getEmployeeSideMenus..........................................................
  getEmployeeSideMenus() {
    this.OnboardService.getsideMenuforEmployeeOnboarding().subscribe((data: any) => {
      this.setMenudata(data);
      localStorage.setItem("CFSS_sidebars", JSON.stringify(data));
    },
      (err: any) => {
        if (err) {

          this.toasterService.error(err, 'Error'), 8000;
        }
      })
  }
  // ................................setMenudata.......................................................................
  setMenudata(data) {
    let menu: any = []
    let i: number = 1;
    data.forEach(element => {
      let temp: any = {}
      temp.id = i;
      temp.title = element.title;
      temp.routerLink = element.routerLink;
      temp.href = null;
      temp.icon = element.icon;
      temp.target = null;
      temp.parentId = 0;
      if (element.children != null && element.children.length > 0) {
        let j: number = i + 1;
        element.children.forEach(element => {
          let submenu: any = {}
          submenu.id = j;
          submenu.title = element.title;
          submenu.routerLink = element.routerLink;
          submenu.href = null;
          submenu.icon = element.icon != undefined ? element.icon : null;
          submenu.target = null;
          submenu.hasSubMenu = false;
          submenu.parentId = i;
          menu.push(submenu);
          j++;
        });
        i = j - 1;
        temp.hasSubMenu = true;
      }
      else {
        temp.hasSubMenu = false;
      }
      menu.push(temp);
      i++;
    });
    this.global.sideMenuItems = menu;
    localStorage.setItem("CFSS_menulist", JSON.stringify(this.global.sideMenuItems));

  }
  	newtab(Clientid) {
    this.global.isClientNewTab = true;
    this.global.EventClientid = Clientid;
    this.global.searchClientStatus = "Active";
    let ClientShortFunctionality = {
      isClientNewTab: this.global.isClientNewTab,
      ClientId: this.global.EventClientid,
    };

    const clientUrl = this.router.serializeUrl(
      this.router.createUrlTree(["/Client"])
    );
   
      window.open("#" + clientUrl, "_blank");
      localStorage.setItem(
        "cfss_ClientNewTabFunctionality",
        JSON.stringify(ClientShortFunctionality)
      );
  }
}





